/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';


export interface UsageConfigSpec { 
    billable: boolean;
    /**
     * Usage config name to push.
     */
    key: string;
    required: boolean;
    tenant_visible: boolean;
    /**
     * Usage Type
     */
    usage_type: string;
    vcds_service_type: VcdsServiceTypeEnum;
}
export namespace UsageConfigSpec {
}


